import type { Project } from '@shared/models/project.model';
import { useProjectStateStore } from '@client/store/project/project.store';

type AssertDesignPersistProjectIsActiveOptions = {
  projectId: Project['id'];
  errorMessage: string;
};

/**
 * Stop an asynchronous design persist before it can write into another project.
 */
export const assertDesignPersistProjectIsActive = ({
  projectId,
  errorMessage,
}: AssertDesignPersistProjectIsActiveOptions): void => {
  if (useProjectStateStore.getState().project.id === projectId) return;
  throw new Error(errorMessage);
};
